@if (show && form) {
  <div [formGroup]="form">
    <jui-number-input
      [size]="controlSize"
      [value]="question.defaultValue"
      [icon]="question.numberIcon"
      [formControlName]="question.key"
      [name]="question.key"
      [label]="question.label"
      [help]="question.numberHelp"
      [format]="question.format"
      [dataqastring]="question.key + 'Input'"
      [required]="question.required ?? false"
      [readonly]="question.readOnly"
      [min]="question.numberMin ?? 0"
      [max]="question.numberMax"
      [step]="question.numberStep ?? 1"
      [precision]="question.precision"
      [disable]="form.get(question.key)?.disabled"
      [errors]="form.get(question.key)?.errors"
      [messages]="buildMessages(this.form, this.question, this.i18ns)"
      [tooltip]="question.hint"
      [validation]="'onLoad'"
      [locale]="question.numberLocale"
      [align]="question.numberAlign"
      [numstyle]="question.numberStyle"
      [currency]="question.numberCurrency"
    ></jui-number-input>
  </div>
}
